<template>
  <section class="mb-12">
    <h2 class="text-2xl md:text-3xl font-display font-bold text-gray-900 dark:text-white mb-6">
      {{ title }}
    </h2>
    <div class="prose prose-lg dark:prose-invert max-w-none">
      <slot />
    </div>
  </section>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  }
});
</script>

<style scoped>
.prose :deep(p) {
  @apply text-gray-600 dark:text-gray-300 mb-4 leading-relaxed;
}

.prose :deep(ul) {
  @apply list-disc pl-6 mb-4 space-y-2;
}

.prose :deep(ol) {
  @apply list-decimal pl-6 mb-4 space-y-2;
}

.prose :deep(li) {
  @apply text-gray-600 dark:text-gray-300;
}

.prose :deep(strong) {
  @apply text-gray-900 dark:text-white font-semibold;
}

.prose :deep(h3) {
  @apply text-xl font-display font-bold text-gray-900 dark:text-white mt-6 mb-3;
}

.prose :deep(a) {
  @apply text-primary dark:text-accent hover:underline;
}
</style>
